import axios from '../request/http';
const Login = {

    // 获取手机验证码
    getPhoneCode(params) {
        return axios.get("/api/login/send/phone_code", { params });
    },
    doPhoneLogin(data) {
        return axios.post("/service-user/passport/doPhoneLogin", data);
    },

    getSMSCode(params) {
        return axios.get("/service-user/passport/getSMSCode", { params });
    },
    // 获取微信授权签名参数
    getweixin(params) {
        return axios.get("/service-app/index/app/open", { params });
    },
    // 手机登录
    getphoneLogin(data) {
        return axios.post("/api/login/app_phone", data);
    },
    // 获取个人信息
    getuserinfo(params) {
        return axios.get("/api/user/info", { params });
    },
    // 获取商品详情
    getGoodsInfo(params) {
        return axios.get("/hemei-order/agricultural/goodsInfo", { params });
    },
    // 获取商品评价
    getGoodsEvaluate(params) {
        return axios.get("/hemei-order/agricultural/getGoodsEvaluate", { params });
    },
    // 文章详情
    detailportal(params) {
        return axios.get("/service-article/portal/article/articleDetail", { params });
    },

    //用户评论数查询
    commentCounts(params) {
        return axios.get("/service-article/comment/counts", { params });
    },
    //评论列表
    commentList(params) {
        return axios.get("/service-article/comment/list", { params });
    },
    //获取乡村详情
    getVillageDetail(params) {
        return axios.get("/service-app/village/detail", { params });
    },
    //获取乡村文化
    getRuralCulture(params) {
        return axios.get("/service-app/culture/culture/list", { params });
    },
    // 查询周边信息
    getAreaInfo(params) {
        return axios.get("/service-app/village/arround/list", { params });
    },
    // 查询版本最新信息
    getNewestAppVersionInfo(params) {
        return axios.post("/hemei-admin/appVersion/getNewestAppVersionInfo", null, { params });
    },
    // 查询文章详情
    articleDetail(params) {
        return axios.get("/service-article/portal/article/articleDetail", { params });
    },
    //获取资讯评论树形结构 
    CommentTree(params) {
        return axios.get("/service-article/comment/new/getArticle/CommentTree", { params });
    },
    // 获取评价列表
    getCommentList(params) {
        return axios.get("/service-article/comment/new/getList", { params });
    },
    // 获取党组织信息
    getPartyList(params) {
        return axios.get("/service-app/party/party/memberDetail", { params });
    },
    // 获取文章列表
    getArticleList(params) {
        return axios.get("/service-article/portal/article/getList", { params });
    },
    // 获取乡村关注数
    getFollowVillageCount(params) {
        return axios.get("/service-user/follower/followVillageCount", { params });
    },
    // 获取谱系树
    treePedigree(params) {
        return axios.get("/hemei-admin/village/genealogy/pedigree/tree", { params });
    },
    // 获取评论第一层结构
    firstFloorComment(params) {
        return axios.get("/service-article/comment/comment/first/floor", { params });
    },
    // 获取评论第二层结构
    secondFloorComment(params) {
        return axios.get("/service-article/comment/comment/second/floor", { params });
    },
    // 获取乡村族谱信息列表详情
    GenealogyDetail(params) {
        return axios.get("/service-app/app/Genealogy/detail", { params });
    },
    // 族员统计人数
    pedigreecount(params) {
        return axios.get("/service-app/village/genealogy/pedigree/count", { params });
    },
    // 文章列表
    articlePage(params) {
        return axios.get("/service-article/app/genealogy/article/page", { params });
    },
    // 文章详情
    articledetail(params) {
        return axios.get("/service-article/app/genealogy/article/detail", { params });
    },
    // 族谱 第一层评论
    firstfloor(params) {
        return axios.get("/service-article/app/genealogy/article/comment/first/floor", { params });
    },
    // 族谱 第二层评论
    secondfloor(params) {
        return axios.get("/service-article/app/genealogy/article/comment/second/floor", { params });
    }
    ,
    //加密页访问族谱校验
    accessGenealogyCheck(data) {
        return axios.post("/service-app/app/Genealogy/access/accessGenealogyCheck", data);
    },
    // 族谱 第二层评论
    secondfloor(params) {
        return axios.get("/service-article/app/genealogy/article/comment/second/floor", { params });
    },
    //热门景点详情
    villageDtail(id) {
        return axios.get(`/service-app/village/scenic/${id}`,);
    },
    //玩什么文章详情
    guideDtail(id) {
        return axios.get(`/service-app/travel/guide/${id}`,);
    },
    //推荐路径详情
    routeDtail(id) {
        return axios.get(`/service-app/village/route/${id}`,);
    },
    //住详情
    getHomestayDetail(params) {
        return axios.get(`/service-app/app/homestay/getHomestayDetail`, { params });
    },
    getchildren(params) {
        return axios.get("/service-app/village/children/areaId", { params });
    },
    cityList(params) {
        return axios.get("/service-app/village/city/list", { params });
    },
    villageSearch(params) {
        return axios.get("/service-app/village/search", { params });
    },
    regionList(params) {
        return axios.get("/service-app/region/list", { params });
    },
    householderList(params) {
        return axios.get("/service-app/family/all/page/V2", { params });
    },
    // 村民入驻
    workflowapproval(data) {
        return axios.post("/service-app/village/approval/workflow/bind/approval", data);
    },
    // 村干部入驻
    approvalcadre(data) {
        return axios.post("/service-app/village/approval/workflow/bind/approval/cadre", data);
    },
    // 申请乡村
    villageapply(data) {
        return axios.post("/service-app/village/apply", data);
    },
    // 乡村合作申请状态查询接口
    applystatus(params) {
        return axios.get("/service-app/village/apply/status", { params });
    },
    // 干部审批申请状态
    bindapproval(params) {
        return axios.get("/service-app/village/approval/workflow/my/cadre/bind/approval/status", { params });
    },
    // 我的村民审批申请状态
    approvalstatus(params) {
        return axios.get("/service-app/village/approval/workflow/my/bind/approval/status", { params });
    },
    // 资料审批
    approvaldetail(params) {
        return axios.get("/service-app/village/approval/workflow/update/user/approval/detail", { params });
    },
    // 获取用户基本信息
    getBaseInfo(params) {
        return axios.get("/service-user/user/getBaseInfo", { params });
    },
    //审批同意和拒绝
    workflowApproval(data) {
        return axios.post("/service-app/village/approval/workflow/approval", data);
    },
    // 村民/村干部入驻申请详情
    bindapprovaldetail(params) {
        return axios.get("/service-app/village/approval/workflow/bind/approval/detail", { params });
    },
    // 文章详情查询
    articleDetail(params) {
        return axios.get("/service-article/portal/article/articleDetail", { params });
    },

    // 积分审批审批详情
    detailApproval(params) {
        return axios.get("/service-app/score/approval/detail", { params });
    },
    detailPage(params){
        return axios.get("/service-app/culture/culture/detail", { params });
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/api/Login.js